import { useContext } from 'react';
import AuthContext from '../context/authContext';
import useHttp from './useHttp';

const useCompetitorAvailability = () => {
  const authCtx = useContext(AuthContext);
  const { sendRequest, isLoading, error } = useHttp();

  const getCompetitors = async () => {
    return sendRequest({
      url: '/api/v1/competitorAvailability/competitors',
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
  };

  const updateCompetitorDefaults = async ({ competitorKey, benchmarkEntertainmentIds, entertainmentType }) => {
    return sendRequest({
      url: `/api/v1/competitorAvailability/competitors/${encodeURIComponent(String(competitorKey || '').trim())}`,
      method: 'PATCH',
      headers: {
        ...authCtx.getAuthHeaders(),
        'Content-Type': 'application/json',
      },
      body: {
        benchmarkEntertainmentIds: Array.isArray(benchmarkEntertainmentIds) ? benchmarkEntertainmentIds : [],
        entertainmentType: entertainmentType || undefined,
      },
    });
  };

  return {
    isLoading,
    error,
    getCompetitors,
    updateCompetitorDefaults,
  };
};

export default useCompetitorAvailability;
